import React from "react";

import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { Grid, Container } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import { Link } from "react-router-dom";
//Components
const react_app_base_url = process.env.REACT_APP_BASE_URL;

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const IndexHeader = () => {
  return (
    <>
      <Grid container className="header-height">
        <Container maxWidth="lg" className="header-container">
          <Grid item xs={4}>
            <Link to="/">
              <img className="top-logo" src={`${react_app_base_url}images/logo.png`} alt="moneytrek logo"/>
            </Link>
          </Grid>

          <Grid item>
            <Link to="/web">
              <Avatar />
            </Link>
          </Grid>
        </Container>
      </Grid>
    </>
  );
};

export default IndexHeader;
